import { render, staticRenderFns } from "./xuanzeZw.vue?vue&type=template&id=ce81653e&scoped=true&"
import script from "./xuanzeZw.vue?vue&type=script&lang=js&"
export * from "./xuanzeZw.vue?vue&type=script&lang=js&"
import style0 from "./xuanzeZw.vue?vue&type=style&index=0&id=ce81653e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce81653e",
  null
  
)

export default component.exports